import React, { useEffect, useMemo, useState } from "react";
import threedots from "../../../images/threedots.svg";
import logoGold from "../../../images/logoGold.svg";
import logoRetro from "../../../images/logoRetro.svg";
import logoClassic from "../../../images/logoClassic.svg";
import logoPlus from "../../../images/logoPlus.svg";
import logoBaratico from "../../../images/logoBaratico.svg";
import logoMotoRider from "../../../images/logoMotoRider.png";
import logoRidery from "../../../images/logoRidery.svg";
import logoBera from "../../../images/bera.png";
import { AltButton, ActionButton } from "../Buttons/Buttons";
import {
  paintCard,
  exists,
  capitalize,
  scheduleFinalColor,
  lastUpdateInMin
} from "../../../assets/helpers/funciones";
import {
  validateTowImages,
  validateServicePayment,
  validateBikeImages,
  hasTowService,
  hasBikeService,
  canFinishPendingLoadCase,
  canLoadLocksmithReimbursement,
  getLocksmithService,
  isLocksmithFinishDisabled,
} from "../../../assets/helpers/caseValidations";
import {
  membershipCodes,
  planStatus,
  enumStatus,
  SERVICE_STATUS,
  incidenceColumnsEnum,
  particularServices,
  PapStatus,
  afiliatedServices
} from "../../../assets/helpers/options";
import {
  caseType,
  PaymentStatus,
  statusEnum,
  membershipStatus,
} from "../../../assets/helpers/options";
import {
  SMSServiceLogo,
  EstimatedTime,
} from "../../views/Incidence/IndicenceButtons";
import { hideForOperators } from "../../../assets/helpers/funciones";
import moment from "moment";
import "./Cards.scss";
import authService from "../../../services/authService";
import { operationsRoles } from "../../../assets/helpers/roles";
import { timeParamsService } from "../../../services/timeParamsService";
import {
  getStatusDeadlines,
  getStatusCountdown,
  formatCountdown,
} from "../../../assets/helpers/statusCountdown";
import {
  useNow,
  usePhaseChangeRefresh,
} from "../../../assets/helpers/useStatusTimers";

const normalizeStatusKey = (status) => String(status || "").trim().toLowerCase();

const isFixedTimeType = (timeType) => {
  if (timeType == null) return true;
  return !/map|google/i.test(String(timeType));
};

const buildTimeParamsByStatus = (timeParams) => {
  if (!Array.isArray(timeParams)) return {};

  return timeParams.reduce((acc, row) => {
    if (!isFixedTimeType(row?.timeType)) {
      return acc;
    }

    const statusKey = normalizeStatusKey(row?.stage || row?.status || row?.name);
    if (!statusKey) {
      return acc;
    }

    const limitTime = Number(row?.limitTime);
    const criticTime = Number(row?.criticTime);
    if (!Number.isFinite(limitTime) && !Number.isFinite(criticTime)) {
      return acc;
    }

    acc[statusKey] = { limitTime, criticTime };
    return acc;
  }, {});
};

const useTimeParamsByStatus = () => {
  const [timeParamsByStatus, setTimeParamsByStatus] = useState({});

  useEffect(() => {
    let isMounted = true;

    timeParamsService
      .list()
      .then((response) => {
        if (!isMounted) return;
        if (response?.status === 200 && response?.data?.timeParams) {
          setTimeParamsByStatus(buildTimeParamsByStatus(response.data.timeParams));
          return;
        }
        setTimeParamsByStatus({});
      })
      .catch(() => {
        if (isMounted) {
          setTimeParamsByStatus({});
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return timeParamsByStatus;
};

// Contador regresivo del tiempo estandar del estatus actual.
// Se define a nivel de modulo (no dentro de IncidenceCards) para que solo este
// nodo se re-renderice cada segundo y no se remonte con la tarjeta.
export const StatusCountdown = ({ _case, timeParamsByStatus }) => {
  const hasCountdown = !!getStatusDeadlines(_case, timeParamsByStatus);
  const now = useNow(hasCountdown);

  if (!hasCountdown) return null;
  const countdown = getStatusCountdown(_case, timeParamsByStatus, now);
  if (!countdown) return null;

  const isOk = countdown.phase === "ok";
  const modifier = isOk && countdown.isSoon ? "soon" : countdown.phase;

  return (
    <p
      className={`incidence-card-countdown incidence-card-countdown--${modifier}`}
      title="Tiempo estándar del estatus actual"
    >
      {isOk ? "Tiempo restante: " : "Excedido: "}
      <b>
        {isOk
          ? formatCountdown(countdown.remainingMs + 999)
          : "+" + formatCountdown(countdown.overdueMs)}
      </b>
    </p>
  );
};

export const MembershipLogo = (props) => {
  const { code } = props;

  if (code === membershipCodes.GOLD) {
    return (
      <img className="case-membership-logo" src={logoGold} alt={"logo"}></img>
    );
  }
  if (code === membershipCodes.GOLDM) {
    return (
      <img className="case-membership-logo" src={logoGold} alt={"logo"}></img>
    );
  }
  if (code === membershipCodes.RETRO) {
    return (
      <img className="case-membership-logo" src={logoRetro} alt={"logo"}></img>
    );
  }
  if ([membershipCodes.PLUS, membershipCodes.PLUSF4]?.includes(code)) {
    return (
      <img className="case-membership-logo" src={logoPlus} alt={"logo"}></img>
    );
  }

  if (code === membershipCodes.BARATICO) {
    return (
      <img
        className="case-membership-logo"
        src={logoBaratico}
        alt={"logo"}
      ></img>
    );
  }

  if (code === membershipCodes.RIDERY) {
    return (
      <img
        className="case-membership-logo"
        src={logoRidery}
        alt={"logo"}
        style={{ maxHeight: "40px" }}
      ></img>
    );
  }

  if (code === membershipCodes.CLASSIC) {
    return (
      <img
        className="case-membership-logo"
        src={logoClassic}
        alt={"logo"}
      ></img>
    );
  }
  if (code === membershipCodes.MOTORIDER) {
    return (
      <img
        className="case-membership-logo"
        src={logoMotoRider}
        alt={"logo"}
      ></img>
    );
  }
  if (code === membershipCodes.BERA) {
    return (
      <img
        className="case-membership-logo"
        src={logoBera}
        alt={"logo"}
      ></img>
    );
  } else return null;
};

export const PlanStatus = (props) => {
  const { label, membership } = props;
  let status = "false";
  let newLabel = label;

  if (
    [
      PapStatus.ACTIVE,
      PapStatus.TO_RENEW,
      planStatus.ACTIVE,
      planStatus.TO_BE_RENEW,
      planStatus?.RENOVADO,
    ].includes(label)
  ) {
    status = "true";
    newLabel = "Activo";
  }
  if ([planStatus.WAITING_TO_BE_EXPIRED].includes(label)) {
    status = "true";
    newLabel = "Esperando Vencimiento";
  }
  if (["Bloqueado"].includes(label)) {
    status = "false";
    newLabel = "Bloqueado";
  }

  if ([planStatus.EXPIRED, planStatus.TO_BE_EXPIRED, PapStatus.EXPIRED, PapStatus.WAIT_EXPIRATION].includes(label)) {
    status = "false";
    newLabel = "Vencido";
  }

  if ([planStatus.WAITING].includes(label)) {
    status = "false";
    newLabel = label;
  }

  return (
    <div className="plan-card-status-container">
      <div className={`plan-card-status plan-card-status-${status}`}>
        {capitalize(newLabel)}
      </div>
      {membership?.annullationReason && (
        <h6 style={{ textAlign: "center", marginTop: "12px" }}>
          {membership?.annullationReason}
        </h6>
      )}
    </div>
  );
};

export const IncidenceColumn = (props) => {
  const {
    cases,
    options,
    actionButtons,
    statusButtons,
    title,
    caseStatus,
    status,
    handleSMSModal,
    handleSelectService,
    handleReembolsoModal,
    actions,
  } = props;
  const timeParamsByStatus = useTimeParamsByStatus();
  if (
    [operationsRoles?.OPERATIONS_FLOTA_AV]?.includes(
      authService?.getUserType()
    ) &&
    ![
      incidenceColumnsEnum?.AV_ASIGNADO,
      incidenceColumnsEnum?.AV_EN_VIA,
      incidenceColumnsEnum?.AV_EN_ORIGEN,
    ]?.includes(title)
  ) {
    return null;
  }

  if (
    [operationsRoles?.OPERATIONS_FLOTA_GRUA]?.includes(
      authService?.getUserType()
    ) &&
    [
      incidenceColumnsEnum?.ORDEN_NO_CREADA,
      incidenceColumnsEnum?.AV_ASIGNADO,
      incidenceColumnsEnum?.AV_EN_VIA,
      incidenceColumnsEnum?.AV_EN_ORIGEN,
    ]?.includes(title)
  ) {
    return null;
  }

  if (
    (!caseStatus &&
      ![enumStatus.FINISHED, enumStatus.FAILED]?.includes(status)) ||
    (caseStatus === enumStatus.FINISHED &&
      [enumStatus.FINISHED, enumStatus.FAILED]?.includes(status)) ||
    (caseStatus === enumStatus.SCHEDULED &&
      [enumStatus.SCHEDULED]?.includes(status)) ||
    (caseStatus === enumStatus?.PENDING_PAYMENT &&
      ![enumStatus?.INITIATED]?.includes(status))
  ) {
    return (
      <div className="vertical-incidence-container">
        <IndicenceHeaderCard
          title={title}
          cases={cases}
          timeParamsByStatus={timeParamsByStatus}
        />
        <div className="vertical-incidence-break-container">
          {cases.map((c) => (
            <IncidenceCards
              key={c?._id}
              _case={c}
              options={options}
              actionButtons={actionButtons}
              statusButtons={statusButtons}
              handleSMSModal={handleSMSModal}
              handleSelectService={handleSelectService}
              handleReembolsoModal={handleReembolsoModal}
              actions={actions}
              timeParamsByStatus={timeParamsByStatus}
            />
          ))}
        </div>
      </div>
    );
  } else return null;
};

export const IndicenceHeaderCard = (props) => {
  const { title, cases, timeParamsByStatus } = props;

  // Repinta la cabecera solo cuando algun caso cruza su tiempo limite/critico
  usePhaseChangeRefresh(cases, timeParamsByStatus);

  return (
    <div
      className={`facturacion-component card indicator-component-header incidence-card-${paintCard(
        cases,
        timeParamsByStatus
      )}`}
    >
      <h6 title={title}>{title}</h6>
      <div className="facturacion-component-quantity">
        <span>{cases?.length}</span>
      </div>
    </div>
  );
};

export const IncidenceCards = (props) => {
  let {
    _case,
    actions,
    options,
    statusButtons,
    actionButtons,
    handleSMSModal,
    handleSelectService,
    handleImageModalForOperator,
    handleReembolsoModal,
    timeParamsByStatus,
  } = props;
  const [showOptions, setShowOptions] = useState(false);
  // Si el caso tiene cerrajeria, su logo reemplaza al del servicio actual (ej. grua)
  const serviceLogoCode = _case?.services?.some(
    (s) => s?.product?.code === afiliatedServices.LOCKSMITH
  )
    ? afiliatedServices.LOCKSMITH
    : _case?.lastService?.product?.code;
  const localTimeParamsByStatus = useTimeParamsByStatus();
  const cardTimeParamsByStatus =
    timeParamsByStatus && Object.keys(timeParamsByStatus).length > 0
      ? timeParamsByStatus
      : localTimeParamsByStatus;

  // Repinta el borde solo cuando este caso cruza su tiempo limite/critico
  const phaseRefreshCases = useMemo(() => [_case], [_case]);
  usePhaseChangeRefresh(phaseRefreshCases, cardTimeParamsByStatus);

  // if (!_case?.lastService?.provider?.isInternal) {
  //   options = options?.filter((o) => o?.name !== 'Cambiar Gruero');
  // }

  const TrackingDate = (props) => {
    const { _case } = props;

    if (_case?.services?.length > 0 && _case?.services[0]?.tripTracking) {
      const tracking = _case?.services[0]?.tripTracking?.trackings?.filter(
        (t) => !t?.when
      );

      return (
        <>
          <br />
          <b>Viaje:</b>{" "}
          {moment(_case?.services[0]?.tripTracking?.tripDate).format(
            "DD/MM/YYYY"
          )}
          <br />
          {tracking?.length > 0 && (
            <>
              <b>Prox seguimiento:</b>{" "}
              {moment(tracking[0]?.scheduled).format("DD/MM/YYYY LTS")}
            </>
          )}
        </>
      );
    } else return null;
  };

  const handlePaymentStatus = () => {
    if (
      _case?.lastService?.paymentStatus === PaymentStatus?.CUENTA_POR_COBRAR &&
      !_case?.lastService?.pendingPayment?.pending
    ) {
      return "Pago realizado";
    } else {
      return exists(_case?.lastService?.paymentStatus);
    }
  };
  return (
    <>
      <div
        style={{
          background: scheduleFinalColor(_case),
        }}
        onClick={() => console.log("Case", _case)}
        className={`card incidence-card-${paintCard([_case], cardTimeParamsByStatus)}`}
      >
        <div className="incidence-component-header">
          <h6>Nro. {_case?.caseId}</h6>
          <div className="incidence-component-code-header">
            <h6 style={{ textAlign: "right" }}>
              {[caseType.AFFILIATED]?.includes(_case?.caseType) ? (
                <>
                  {exists(_case?.membership?.code?.prefixCode || _case?.papMembership?.code)} -
                  {exists(_case?.membership?.saleChannel?.shortName || _case?.papMembership?.saleChannel?.shortName)}-
                  {exists(_case?.membership?.membershipId || _case?.papMembership?.membershipId)}
                </>
              ) : (
                caseType.PRIMARY_CARE === _case?.caseType ? "Afiliado" : "Cliente no Afiliado"
              )}
              <br />
              {_case?.caseType}
            </h6>
            <StatusHandler
              _case={_case}
              options={options}
              show={showOptions}
              handleOpen={setShowOptions}
            />
          </div>
        </div>
        {!hideForOperators() && (
          <>
            <br />
            <h6 style={{ textAlign: "center" }}>
              {`${_case?.status}`.toUpperCase()}
            </h6>
          </>
        )}
        <br />
        <div className="row card-row-container">
          <div className="col-10">
            {_case?.caseType === caseType.PRIMARY_CARE && (
              <h5>
                {capitalize(_case?.vehicleData?.firstName) +
                  " " +
                  capitalize(_case?.vehicleData?.lastName)}{" "}
              </h5>
            )}
            {_case?.caseType === caseType.AFFILIATED && (
              <h5>
                {capitalize(_case?.membership?.customer?.firstName) +
                  " " +
                  capitalize(_case?.membership?.customer?.lastName)}{" "}
              </h5>
            )}
            {_case?.caseType === caseType.PARTICULAR && (
              <h5>
                {capitalize(_case?.particularCustomer?.firstName) +
                  " " +
                  capitalize(_case?.particularCustomer?.lastName)}{" "}
              </h5>
            )}
            {_case?.caseType === caseType.ALLY && (
              <>
                <h5>
                  {capitalize(_case?.vehicleData?.firstName) +
                    " " +
                    capitalize(_case?.vehicleData?.lastName)}{" "}
                </h5>
                <h6>{_case?.businessAlly?.enterprise?.name} </h6>{" "}
              </>
            )}
          </div>
          <div style={{ padding: "0px" }} className="col-2">
            <MembershipLogo code={_case?.membership?.code?.code} />
          </div>
          <div className="col-12">
            {_case?.caseType === caseType.AFFILIATED && (
              <h6 className="incidence-component-vehicle">
                {exists(_case?.membership?.vehicle?.plate) +
                  " " +
                  capitalize(_case?.membership?.vehicle?.brand) +
                  " " +
                  capitalize(_case?.membership?.vehicle?.model) +
                  " " +
                  exists(_case?.membership?.vehicle?.year) +
                  " " +
                  capitalize(_case?.membership?.vehicle?.color)}
              </h6>
            )}

            {_case?.caseType === caseType.PARTICULAR && (
              <h6 className="incidence-component-vehicle">
                {exists(_case?.particularCustomer?.vehiclePlate) +
                  " " +
                  capitalize(_case?.particularCustomer?.vehicleBrand?.brand) +
                  " " +
                  capitalize(_case?.particularCustomer?.vehicleModel?.model) +
                  " " +
                  exists(_case?.particularCustomer?.vehicleYear) +
                  " " +
                  capitalize(_case?.particularCustomer?.vehicleColor)}
              </h6>
            )}

            {[caseType.ALLY, caseType.PRIMARY_CARE]?.includes(_case?.caseType) && (
              <h6 className="incidence-component-vehicle">
                {exists(_case?.vehicleData?.plate) +
                  " " +
                  capitalize(_case?.vehicleData?.brand?.brand) +
                  " " +
                  capitalize(_case?.vehicleData?.model?.model) +
                  " " +
                  exists(_case?.vehicleData?.year) +
                  " " +
                  capitalize(_case?.vehicleData?.color)}
              </h6>
            )}
          </div>
          <br />
          <div className="col-12 incidence-card-text">
            <p>
              <b>Ruta:</b> {capitalize(_case?.originCity?.name)}{" "}
              {_case?.destinyCity?.name
                ? "a " + capitalize(_case?.destinyCity?.name)
                : ""}
              {![_case?.status]?.includes(enumStatus?.FOLLOW_UP) && (
                <>
                  <br />
                  <b>Avería:</b> {capitalize(_case?.fault?.description)}
                </>
              )}
              {_case?.lastService?.provider?.contactName &&
                _case?.lastService?.product?.code !== afiliatedServices.LOCKSMITH && (
                <>
                  <br />
                  <b>
                    Proveedor (
                    {_case?.lastService?.provider?.isInternal
                      ? "Interno"
                      : "Externo"}
                    ) :
                  </b>{" "}
                  {capitalize(_case?.lastService?.provider?.contactName)}
                </>
              )}
              {![_case?.status]?.includes(enumStatus?.FOLLOW_UP) && (
                <EstimatedTime
                  service={_case?.lastService?.product?.code}
                  grua={"grua"}
                />
              )}
              <br />
              <b>Operador:</b> {exists(_case?.user?.firstName)}{" "}
              {exists(_case?.user?.lastName)}
              {_case?.createdBy?.firstName && (
                <>
                  <br />
                  <b>Gestionado:</b>{" "}
                  {capitalize(_case?.createdBy?.firstName) +
                    " " +
                    capitalize(_case?.createdBy?.lastName)}
                </>
              )}
              <TrackingDate _case={_case} />
              {[
                enumStatus?.FINISHED,
                enumStatus?.FAILED,
                enumStatus?.CANCELED,
              ]?.includes(_case?.status) &&
                _case?.user && (
                  <>
                    <br />
                    <b>Finalizado:</b>{" "}
                    {capitalize(_case?.user?.firstName) +
                      " " +
                      capitalize(_case?.user?.lastName)}
                  </>
                )}
            </p>
            {_case?.lastService?.paymentStatus &&
              _case?.lastService?.paymentStatus ===
              PaymentStatus?.CUENTA_POR_COBRAR && (
                <p className="incidence-card-creation-date">
                  <b>Estatus de Pago: </b>
                  {handlePaymentStatus(_case)}
                </p>
              )}

            {_case?.scheduleDate && (
              <p className="incidence-card-creation-date">
                <b> Fecha y hora del servicio:</b> <br />
                {exists(moment(_case?.scheduleDate).format("DD/MM/YYYY LTS"))}
              </p>
            )}

            <p className="incidence-card-creation-date">
              Última modificación:  <b>{" " + lastUpdateInMin(_case?.lastStage?.createdAt) + " min"}</b><br />
              {exists(
                moment(_case?.lastStage?.updatedAt).format("DD/MM/YYYY LTS")
              )} <b>
              </b>
              <br />
              <br /> Creado :{" "}
              {exists(moment(_case?.createdAt).format("DD/MM/YYYY LTS"))}
            </p>

            <StatusCountdown
              _case={_case}
              timeParamsByStatus={cardTimeParamsByStatus}
            />
            {_case?.taxi &&
              <h6 style={{ fontSize: "14px", margin: "0px", fontWeight: "bold" }}>Servicio de taxi aplicado</h6>
            }
          </div>


          {_case?.lastService?.code && (
            <div className="icon-service-code-container">
              {_case?.lastService?.code && (
                <p>{exists(_case?.lastService?.code)}</p>
              )}
              <div className="av-extended-icon-container">
                {_case?.thirdPartyService && <p>AV extendido</p>}
                <SMSServiceLogo
                  service={serviceLogoCode}
                  action={() => handleSMSModal(_case)}
                />
              </div>
            </div>
          )}
          {_case?.status === enumStatus?.SEARCHING_TOW &&
            !_case?.lastService?.code && (
              <div className="icon-service-code-container">
                {<p></p>}
                <div className="av-extended-icon-container">
                  {_case?.thirdPartyService && <p>AV extendido</p>}
                  <SMSServiceLogo
                    service={serviceLogoCode}
                    action={() => handleSMSModal(_case)}
                    grua={"grua"}
                  />
                </div>
              </div>
            )}

          {validateTowImages(_case) && (
            <div className="crane-image-missing">
              <h6>Falta cargar imágenes de servicio de grúa</h6>
            </div>
          )}

          {validateServicePayment(_case) && (
            <div className="crane-image-missing">
              <h6>Falta realizar pago de servicio</h6>
            </div>
          )}

          {validateBikeImages(_case) && (
            <div className="crane-image-missing">
              <h6>Falta cargar imágenes de servicio Moto</h6>
            </div>
          )}

          {_case?.withoutCityFromChat && (
            <div className="crane-image-missing">
              <h6>Falta completar ciudad y estado (caso desde Chat)</h6>
            </div>
          )}

          <div
            style={{ marginTop: "12px" }}
            className="buttons-center-container"
          >
            {
              // hideForOperators() &&
              actionButtons
                ?.filter((a) => a?.status?.includes(_case?.status))
                ?.map((a) => {
                  if (!hideForOperators()) {
                    if (a.status[0] === enumStatus?.AV_IN_ORIGIN) {
                      return (
                        <AltButton
                          key={a?.name}
                          action={() => a?.action(_case)}
                          label={a?.name}
                        />
                      );
                    } else {
                      return null;
                    }
                  } else {
                    return (
                      <AltButton
                        key={a?.name}
                        action={() => a?.action(_case)}
                        label={a?.name}
                      />
                    );
                  }
                })
            }

            {[
              operationsRoles.OPERATIONS_FLOTA_GRUA,
              operationsRoles.OPERATIONS_FLOTA_GRUA_EXT,
            ].includes(authService?.getUserType()) &&
              hasTowService(_case) &&
              [
                enumStatus.TOW_ON_ROAD,
                enumStatus.TOW_IN_ORIGIN,
                enumStatus.CUSTOMER_ON_ROAD,
              ].includes(_case?.status) &&
              validateTowImages(_case) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <AltButton
                    action={() => handleImageModalForOperator(_case)}
                    label={"Cargar Imagen de Servicio de Grua"}
                  />
                </div>
              )}

            {!!getLocksmithService(_case) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ActionButton
                  action={() => handleReembolsoModal(_case)}
                  label={"Cargar Reembolso"}
                  disabled={!canLoadLocksmithReimbursement(_case)}
                />
              </div>
            )}

            {[
              particularServices.gas,
              particularServices.tire1,
              particularServices.tire2,
              particularServices.battery,
            ].includes(_case?.lastService?.product?.code) &&
              [enumStatus.AV_IN_ORIGIN].includes(_case.status) ? null : (
              <>
                {statusButtons
                  ?.filter((a) => a?.status?.includes(_case?.status))
                  ?.map((a) => {
                    // IF Battery sale Cant set as solved by AV
                    if (_case?.status === enumStatus?.AV_IN_ORIGIN
                      && [
                        particularServices.BATT_SALE_PART,
                        afiliatedServices.BATT_SALE
                      ].includes(_case?.lastService?.product?.code)
                    ) {
                      return null
                    }
                    if (
                      a.name === "Falla extra detect/resuelta" &&
                      [operationsRoles.OPERATIONS_FLOTA_AV].includes(
                        authService?.getUserType()
                      ) &&
                      ![
                        particularServices.gas,
                        particularServices.tire1,
                        particularServices.tire2,
                      ].includes(_case?.lastService?.product?.code)
                    ) {
                      a.name = "Avería resuelta";
                    }
                    return (
                      <StatusActionButton
                        key={a?.name}
                        _case={_case}
                        a={a}
                        actions={actions}
                      />
                    );
                  })}
              </>
            )}
            {_case?.status === enumStatus?.FINISHED &&
              PaymentStatus?.CUENTA_POR_COBRAR &&
              _case?.lastService?.pendingPayment?.pending && (
                <ActionButton
                  action={() => handleSelectService(_case)}
                  label={"Registrar pago"}
                />
              )}
          </div>

          {[operationsRoles.OPERATIONS_FLOTA_AV].includes(
            authService?.getUserType()
          ) &&
            [enumStatus.AV_IN_ORIGIN].includes(_case?.status) &&
            ![
              membershipStatus?.["EN ESPERA"],
              membershipStatus?.PENDIENTE,
            ].includes(_case?.membership?.status) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "12px",
                  marginBottom: "12px",
                }}
              >
                <AltButton
                  action={() => actions?.asignCrane(_case)}
                  label={"Asignar Grúa"}
                />
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export const StatusHandler = (props) => {
  const { options, handleOpen, show, _case } = props;





  if (
    [
      operationsRoles?.OPERATIONS_FLOTA_GRUA,
      operationsRoles?.OPERATIONS_FLOTA_GRUA_EXT,
    ]?.includes(authService?.getUserType())
  ) {
    return null;
  }

  return (
    <>
      <img src={threedots} alt="threedots" onClick={() => handleOpen(!show)} />
      {show && (
        <div className="incidence-status-options-container">
          {options
            ?.filter((o) => o?.status?.includes(_case?.status))
            ?.map((o) => {
              if (
                [membershipCodes?.RIDERY]?.includes(
                  _case?.membership?.code?.code
                ) &&
                (!_case?.towProductQuantity[0] ||
                  _case?.towProductQuantity?.length === 0) &&
                o?.name === statusEnum?.ASIGNAR_GRUA
              ) {
                return null;
              }
              if (
                [operationsRoles?.OPERATIONS_FLOTA_AV]?.includes(
                  authService?.getUserType()
                ) &&
                o?.name !== statusEnum?.REVISION_EXPRESS
              ) {
                return null;
              }


              if (!_case?.scheduleDate && o?.name === statusEnum?.EDITAR_SERVICIO_AGENDADO) {
                return null;
              }

              // PAP cannot assign tow
              if (_case?.papMembership && o.name === statusEnum?.ASIGNAR_GRUA) {
                return null;
              }

              return (
                <Status _case={_case} option={o} handleOpen={handleOpen} />
              );
            })}
        </div>
      )}
    </>
  );
};

const handleSolvedByAV = (_case, option) => {
  let isTow = false;

  for (let i = 0; i < _case?.services?.length; i++) {
    if (_case?.services[i]?.type === "Grua") {
      isTow = true;
    }
  }

  if (
    [statusEnum?.CHANGE_TO_SOLVED, statusEnum?.CHANGE_TO_CHECKING]?.includes(
      option.name
    ) &&
    isTow
  ) {
    return false;
  }

  if (_case.solvedByAV && option.name === statusEnum?.CHANGE_TO_SOLVED) {
    return false;
  }
  if (!_case.solvedByAV && option.name === statusEnum?.CHANGE_TO_CHECKING) {
    return false;
  } else return true;
};

const validateIfHasCashbacks = (services) => {
  let hasCashbacks = false;

  for (let i = 0; i < services?.length; i++) {
    if (services[i]?.paymentChanges?.length > 0) {
      hasCashbacks = true;
    }
  }
  return hasCashbacks;
};

export const Status = (props) => {
  const { _case, option, handleOpen } = props;

  let serivesCounter = 0;

  if (
    [membershipStatus?.["EN ESPERA"], membershipStatus.PENDIENTE].includes(
      _case?.membership?.status
    ) &&
    option?.name === statusEnum?.ASIGNAR_GRUA
  ) {
    return null;
  }
  // Battery purchase service cannot ask for a tow 
  if (
    [
      particularServices.BATT_SALE_PART,
      afiliatedServices.BATT_SALE
    ].includes(_case?.lastService?.product?.code)
    &&
    option?.name === statusEnum?.ASIGNAR_GRUA
  ) {
    return null;
  }

  if (
    !validateIfHasCashbacks(_case?.services) &&
    option?.name === statusEnum?.ACTUALIZAR_VUELTOS
  ) {
    return null;
  }

  if (!handleSolvedByAV(_case, option)) {
    return null;
  }

  if (option?.name === statusEnum?.CARGAR_IMAGEN && !hasBikeService(_case)) {
    return null;
  }

  if (
    option?.name === statusEnum?.CARGAR_IMAGEN_SERVICIO_GRUA &&
    !hasTowService(_case)
  ) {
    return null;
  }

  if (
    option?.name === statusEnum?.CARGAR_REEMBOLSO &&
    !canLoadLocksmithReimbursement(_case)
  ) {
    return null;
  }

  // Solo servicios de grúa pueden alternar entre agendado/normal
  if (
    [
      statusEnum?.CAMBIAR_A_SERVICIO_AGENDADO,
      statusEnum?.CAMBIAR_A_SERVICIO_NORMAL,
    ].includes(option?.name) &&
    !hasTowService(_case)
  ) {
    return null;
  }

  // Cant request a taxi service if there is already a taxi service applied
  if (_case?.taxi && option.name === statusEnum?.SERVICIO_DE_TAXI) {
    return null;
  }

  if (_case.expressCheckupId && option.name === statusEnum?.REVISION_EXPRESS) {
    return null;
  }

  for (let i = 0; i < _case?.services?.length; i++) {
    if (_case?.services[i]?.status !== SERVICE_STATUS?.CANCELLED) {
      serivesCounter++;
    }
  }
  if (option.name === statusEnum?.CANCELAR_SERVICIO && serivesCounter < 2) {
    return null;
  } else {
    return (
      <div
        key={option.name}
        className="incidence-status-options-option"
        onClick={() => {
          option.action(_case);
          handleOpen(false);
        }}
      >
        {option.name}
      </div>
    );
  }
};

export const OperationCard = (props) => {
  const { src, label, value } = props;

  return (
    <div className="card operations-stat-card">
      <div>
        <img src={src} alt="" />
        <h5>{label}</h5>
      </div>
      <h4>{value}</h4>
    </div>
  );
};

const isFinishCaseAction = (action) =>
  /^finalizar caso$/i.test(String(action?.name || "").trim());

export const StatusActionButton = (props) => {
  const { _case, a, actions } = props;

  if (
    isFinishCaseAction(a) &&
    _case?.status === enumStatus.PENDING_LOAD &&
    !canFinishPendingLoadCase(_case, authService?.getUserType())
  ) {
    return null;
  }

  if (_case?.thirdPartyService && _case?.status === enumStatus?.AV_IN_ORIGIN) {
    return (
      <ActionButton
        action={() => actions?.asignCrane(_case)}
        label={"Asignar Grua"}
      />
    );
  }

  // Regular button
  if (_case?.status !== "Servicio Agendado") {
    return (
      <div>
        <ActionButton
          key={a?.name}
          action={() => a?.action(_case, a?.name)}
          label={a?.name}
          disabled={
            isFinishCaseAction(a) && isLocksmithFinishDisabled(_case)
          }
        />
      </div>
    );
  }

  // Start service
  if (
    _case?.status === "Servicio Agendado" &&
    _case?.lastService?.provider &&
    a.name == "Iniciar Servicio"
  ) {
    return (
      <ActionButton
        key={a?.name}
        action={() => a?.action(_case, a?.name)}
        label={a?.name}
      />
    );
  }

  // Schedule service
  if (
    _case?.status === "Servicio Agendado" &&
    !_case?.lastService?.provider &&
    a.name == "Asignar grúa"
  ) {
    return (
      <ActionButton
        key={a?.name}
        action={() => a?.action(_case, a?.name)}
        label={a?.name}
      />
    );
  } else return null;
};
